import * as _ from "lodash";

import { USER_KEY } from "../consts";

export const getUserDataFromLCStorage = () => {
  const user = JSON.parse(localStorage.getItem(USER_KEY));
  return user;
};
export const useAuth = () => {
  const userData = getUserDataFromLCStorage();

  //  check if user login or not
  const isAuthenticated = !_.isEmpty(userData);
  return isAuthenticated;
};

export const convertGenderNam = (gender) => {
  let result = "";
  switch (gender) {
    case "MALE":
      result = "ທ້າວ";
      break;
    case "FEMALE":
      result = "ນາງ";
      break;
    case "MONK":
      result = "ພຣະ";
      break;
    case "OTHER":
      result = "ສຳມະເນນ";
      break;
    case "NOVICE":
      result = "ສຳມະເນນ";
      break;
    default: // Do nothing
  }
  return result;
};
